<template>
  <b-row class="pt-2 scrollable-tab-content m-2">
    <b-col>
      <metadata-node :item="root"/>
    </b-col>
  </b-row>
</template>

<script>
import MetadataNode from "./metadata/MetadataNode";
import { MetadataElement } from "./metadata/metadataElement.js";

export default {
  props: {
    value: { type: Object, required: true }
  },
  components: {
    MetadataNode
  },
  computed: {
    root() {
      return new MetadataElement(this.value);
    }
  }
};
</script>

<style>
.scrollable-tab-content {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: auto;
}

h5,
h6 {
  font-weight: 600;
}

.metadata-list-item div {
  display: inline !important;
}

.metadata-list-group-item {
  border-left: none;
  border-right: none;
  padding: 0.75rem 0rem;
}

.metadata-list-group-item:first-child {
  border-top: none;
}
</style>